export const BLOG_COMPONENTS = {
  basic: [
    "abi_title_image_text",
    "abi_content_block",
    "abi_flexible_alignment_text_block",
    "abi_video",
    "abi_page_header",
    "abi_masonry_grid"
  ],
  special: ["abi_image_slide", "abi_image_slider"]
};
